<template>
  <div v-if="isLoading">
    <base-spinner></base-spinner>
  </div>
  <div class="table" v-else>
    <div class="table-header">
      <div class="header-content">
        <p>Phiếu đăng ký tuyển sinh</p>
        <input style="width: 250px; margin: 0 30px;" v-model="filterTerm" placeholder="Tên học viên" @keyup.enter="sendFilterTerm"/>

        <div style="display: flex; justify-content: center; align-items: center; margin-right: 30px;">
          <p style="margin: 0px 10px;">Từ</p>
          <div style="position: relative;">
            <input type="text" id="date-input" placeholder="dd/mm/yyyy" v-model="startDateValue" @blur="validateStartDateInput">
            <input type="date" v-model="filteredStartDate" @keydown.prevent @input="shareStartdayValue">
          </div>
          <p style="margin: 0px 10px;">đến</p>
          <div style="position: relative;">
            <input type="text" id="date-input" placeholder="dd/mm/yyyy" v-model="endDateValue" @blur="validateEndDateInput">
            <input type="date" v-model="filteredEndDate" @keydown.prevent @input="shareEnddayValue">
          </div>
        </div>

        <button style="background-color: #0298cf; border-radius: 6px; height: 40px;  margin-right: 20px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button style="background-color: #969393; border-radius: 6px; height: 40px;  margin-right: 15px;"
          @click.prevent="clearFilter">
          <div style="display: flex; align-items: center;">
            <i style="margin-right: 5px; font-size: 15px;" class="fa-solid fa-xmark"></i>
            <span>Clear</span>
          </div>
        </button>
      </div>

      <div>
        <!-- <input v-model="filterTerm" placeholder="Tên học viên" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px;  margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button> -->

        <button @click="exportExcel" class="excel-btn" :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="$checkPermission('view_application')">
          <p class="btn-text"><i style="margin-right: 5px;" class="fa-solid fa-file-excel"></i>Xuất Excel</p>
        </button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Họ tên</th>
            <th>Ngày sinh</th>
            <th>Số điện thoại</th>
            <th>Ngày đăng ký</th>
            <th>Tài liệu hiện hữu</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in getApplicationData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.fullName }}</td>
            <td>{{ ctt.formattedBirthday }}</td>
            <td>{{ ctt.phoneNumber }}</td>
            <td>{{ ctt.formattedCreatedAt }}</td>
            <td>
              {{ currentApplicationFile[i] + '/10'}}
            </td>
            <td>
              <div class="action-holder">
                <button style="background-color: rgb(76, 218, 76);" @click="downloadZip(ctt)"
                  v-if="$checkPermission('edit_application')"><i class="fa-solid fa-download"></i></button>
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_application')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_application')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; cursor: default; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- Modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal" size="large">
    <div class="section-btn">
      <div class="switching-btn">
        <button class="toggle-switch-btn" @click.prevent="infoTab">Thông tin</button>
        <button class="toggle-switch-btn" @click.prevent="docsTab">Tài liệu</button>
      </div>
    </div>
    <form @submit.prevent="submitForm">
      <div class="form-body">
        <div style="margin-top: 0.8rem;" v-if="activeTab === 'left'">
          <span>{{ labelFormData.selfInfo }}</span>
          <div class="form-control muti-data" >
            <div class="data-input">
              <label for="name">{{ labelFormData.name }}</label>
              <input type="text" v-model.trim="formData.fullName">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.gender }}</label>
              <div style="display: flex; gap: 0 40px; margin-top: 8px;">
                <label style="display: flex; align-items: center;">
                  <input id="cb" type="radio" :value="true" v-model="formData.gender"
                    style="margin-right: 20px; width: 20px; margin-top: 0px;" />
                  {{ labelFormData.male }}
                </label>
                <label style="display: flex; align-items: center;">
                  <input id="cb" type="radio" :value="false" v-model="formData.gender"
                    style="margin-right: 20px; width: 20px; margin-top: 0px;" />
                    {{ labelFormData.female }}
                </label>
              </div>
            </div>
          </div>
          <!-- blank -->
          <div class="form-control muti-data" >
            <div class="data-input">
              <label>{{ labelFormData.birthday }}</label>
              <p class="formated-date">{{ birthdayValue }}</p>
              <input type="date" v-model="formData.birthday">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.age }}</label>
              <input type="number" v-model.trim="formData.age">
            </div>
          </div>
          <div class="form-control">
            <label>{{ labelFormData.birthPlace }}</label>
            <input type="text" v-model.trim="formData.birthPlace">
          </div>
          <div class="form-control">
            <label>{{ labelFormData.permanentRes }}</label>
            <input type="text" v-model.trim="formData.permanentAddress">
          </div>
          <div class="form-control">
            <label>{{ labelFormData.citizenIdentificationCard }}</label>
            <input type="text" v-model.trim="formData.citizenIdentificationCard">
          </div>
          <div class="form-control muti-data">
            <div class="data-input">
              <label>{{ labelFormData.dateOfIssue }}</label>
              <p class="formated-date">{{ dateOfIssueValue }}</p>
              <input type="date" v-model="formData.dateOfIssue">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.placeOfIssue }}</label>
              <input type="text" v-model.trim="formData.placeOfIssue">
            </div>
          </div>
          <div class="form-control muti-data" >
            <div class="data-input">
              <label>{{ labelFormData.phoneNum }}</label>
              <input type="text" v-model.trim="formData.phoneNumber">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.email }}</label>
              <input type="text" v-model.trim="formData.email">
            </div>
          </div>
          <div class="form-control muti-data">
            <div class="data-input">
              <label>{{ labelFormData.eduLevel }}</label>
              <input type="text" v-model.trim="formData.educationLevel">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.englishCertificate }}</label>
              <input type="text" v-model.trim="formData.englishCertificate">
            </div>
          </div>
          <span>{{ labelFormData.familyInfo }}</span>
          <div class="form-control muti-data">
            <div class="data-input">
              <label>{{ labelFormData.fatherName }}</label>
              <input type="text" v-model.trim="formData.fatherName">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.familyBirthYear }}</label>
              <input type="number" v-model.trim="formData.fatherBirthYear">
            </div>
          </div>
          <div class="form-control muti-data">
            <div class="data-input">
              <label>{{ labelFormData.motherName }}</label>
              <input type="text" v-model.trim="formData.motherName">
            </div>
            <div class="data-input">
              <label>{{ labelFormData.familyBirthYear }}</label>
              <input type="number" v-model.trim="formData.motherBirthYear">
            </div>
          </div>
          <div class="form-control">
            <label>{{ labelFormData.parentPhoneNum }}</label>
            <input type="text" v-model.trim="formData.parentPhoneNum">
          </div>
        </div>

        <div class="form-control" v-if="activeTab === 'right'">
          <span>{{ labelFormData.attachments }}</span>
          <div v-show="smallLoading" style="min-height: 615px;">
            <base-spinner></base-spinner>
          </div>
          <!-- Loop through the file input list -->
          <div v-for="(file, index) in fileList" :key="index" style="margin: 15px 0px;" v-show="!smallLoading">
            <div style="display: flex;" >
              <label>{{ file.title }}</label>
            </div>
            <div class="muti-data" style="margin-top: 0.5rem;">
              <!-- File Upload -->
              <div class="data-input-file">
                <input
                  type="file"
                  @change="changeFile($event, index)"
                  :id="'file-' + index"
                />
                <label :for="'file-' + index"><i class="fa-solid fa-upload"></i>Upload File</label>
              </div>
              <!-- Display File Name and Extension -->
              <div class="data-input" style="padding-top: 5px">
                <div style="height: 100%; width: 350px; display: flex; align-items: center;">
                  <a
                    v-if="file.url"
                    href="#"
                    @click.prevent="downloadFile(file.url, file.name)"
                    class="file-link"
                  >
                    <img :src="require(`../../assets/fileType/${getFileType(file.extension)}`)">
                    {{ truncatedFileName(file.name) }}
                  </a>
                  <span v-if="file.size" style="color: black; font-weight: normal; font-size: 14px; margin-left: 12px">({{ file.size }})</span>
                  <!-- {{ file.name ? `${file.name}` : "" }} -->
                  <i v-if="file.file" class="fa-solid fa-circle-xmark"
                  style="margin-left: 8px; color: red; font-size: 14px; cursor: pointer"
                  @click.prevent="deleteAppFile(index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>

    <div class="btn-container">
      <!-- <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id === 0" @click="createClick()">
        <p class="btn-text">Tạo</p>
      </button> -->
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" @click="updateClick()">
        <p class="btn-text">Cập nhật</p>
      </button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    :requestLoading="requestLoading"
    @delete="deleteClick(selectedId)">
  </alert-modal>
</template>
<script>
import axios from 'axios'
import JSZip from 'jszip'
import { Packer, Document, Paragraph, TextRun, AlignmentType } from 'docx'

export default
{
  data () {
    return {
      activeTab: 'left',
      formData: {
        id: null,
        fullName: null,
        gender: true,
        birthday: null,
        age: null,
        birthPlace: null,
        permanentAddress: null,
        citizenIdentificationCard: null,
        placeOfIssue: null,
        dateOfIssue: null,
        phoneNumber: null,
        email: null,
        educationLevel: null,
        englishCertificate: null,
        fatherName: null,
        motherName: null,
        fatherBirthYear: null,
        motherBirthYear: null,
        parentPhoneNum: null
      },
      fileList: [
        { id: 0, title: 'Đơn xin dự tuyển', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Bản khai lý lịch', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Giấy khai sinh', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Bằng Tốt nghiệp', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Phiếu điểm tiếng Anh', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Hộ chiếu và CCCD Học viên', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'CCCD người bảo lãnh', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Ảnh 4x6 và 3x4', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Phiếu khám sức khỏe', name: '', url: '', extension: '', size: '' },
        { id: 0, title: 'Lý lịch tư pháp', name: '', url: '', extension: '', size: '' }
      ],
      tempFileList: [],
      currentApplicationFile: [],
      loadDocs: true,
      totalPages: 1,
      wordFile: null,
      //
      filterTerm: '',
      appliedTerm: '',
      pageSize: 10,
      currentPage: 1,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      selectedId: 0,
      isLoading: false,
      smallLoading: false,
      propertiesToCheck: ['name'],
      propertiesToBackup: ['id', 'name', 'description', 'serviceId'],
      vnData: {},
      enData: {},
      hasCreatedData: false,
      changeLang: false,
      checkEn: false,
      loadEditData: false,
      originalUrl: '',
      msg: '',
      tempUrl: '',
      requestLoading: false,
      // data
      id: 0,
      name: '',
      url: '',
      isHidden: true,
      followUrl: '',
      description: '',
      routeName: '',
      serviceId: 0,
      lang: 'vn',
      createdAt: '',
      author: '',
      updatedAt: '',
      startDateValue: '',
      filteredStartDate: null,
      endDateValue: '',
      filteredEndDate: null
    }
  },
  computed: {
    getTSeDetails () {
      return this.$store.getters['services/backendTrainingServiceDetail']
    },
    getTSeSelect () {
      return this.$store.getters['services/selectTrainingServices'](this.lang)
    },
    getServiceIdOfOthersLang () {
      if (!this.serviceId && !this.tempUrl) {
        return null
      } else {
        return this.getTSeSelect.find(item => item.url === this.tempUrl).id
      }
    },
    getTempUrl () {
      if (!this.serviceId) {
        return ''
      } else {
        return this.getTSeSelect.find(item => item.id === this.serviceId).url
      }
    },
    // New
    labelFormData () {
      return this.$store.getters['recruit/labelFormData']
    },
    getApplicationData () {
      return this.$store.getters['recruit/backendAppications']
    },
    getbackendAppicationFilesData () {
      return this.$store.getters['recruit/backendAppicationFiles']
    },
    birthdayValue () {
      if (!this.formData.birthday) return 'dd/mm/yyyy'
      const [year, month, day] = this.formData.birthday.split('-')
      return `${day.slice(0, 2)}/${month}/${year}`
    },
    dateOfIssueValue () {
      if (!this.formData.dateOfIssue) return 'dd/mm/yyyy'
      const [year, month, day] = this.formData.dateOfIssue.split('-')
      return `${day.slice(0, 2)}/${month}/${year}`
    }
  },
  methods: {
    clearFilter () {
      this.filteredStartDate = null
      this.filteredEndDate = null
      this.startDateValue = ''
      this.endDateValue = ''
      this.filterTerm = ''
      this.appliedTerm = ''
    },
    checkFilteredDate () {
      if (this.filteredStartDate && this.filteredEndDate) {
        if (this.filteredStartDate <= this.filteredEndDate) {
          this.getApplicationPageData()
        } else {
          this.$showError('Ngày bắt đầu phải bé hơn ngày kết thúc')
        }
      } else if (this.filteredStartDate || this.filteredEndDate) {
        this.getApplicationPageData()
      }
    },
    // StartDate
    validateStartDateInput () {
      if (!this.startDateValue) {
        this.filteredStartDate = ''
        return
      }
      const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(19[7-9][0-9]|20[0-2][0-9])$/
      if (!regex.test(this.startDateValue)) {
        this.$showError('Ngày bắt đầu sai định dạng')
        this.filteredStartDate = ''
        this.startDateValue = ''
        return
      }

      const [day, month, year] = this.startDateValue.split('/').map(Number)
      this.startDateValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`

      this.filteredStartDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
      this.checkFilteredDate()
    },
    shareStartdayValue () {
      const [year, month, day] = this.filteredStartDate.split('-').map(Number)
      this.startDateValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`
      this.checkFilteredDate()
    },
    // EndDate
    validateEndDateInput () {
      if (!this.endDateValue) {
        this.filteredEndDate = ''
        return
      }
      const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(19[7-9][0-9]|20[0-2][0-9])$/
      if (!regex.test(this.endDateValue)) {
        this.$showError('Ngày kết thúc sai định dạng')
        this.filteredEndDate = ''
        this.endDateValue = ''
        return
      }

      const [day, month, year] = this.endDateValue.split('/').map(Number)
      this.endDateValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`

      this.filteredEndDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
      this.checkFilteredDate()
    },
    shareEnddayValue () {
      const [year, month, day] = this.filteredEndDate.split('-').map(Number)
      this.endDateValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`
      this.checkFilteredDate()
    },
    sendFilterTerm () {
      this.currentPage = 1
      this.appliedTerm = this.filterTerm
      this.getApplicationPageData()
    },
    async exportExcel () {
      this.requestLoading = true
      await this.$store.dispatch('recruit/exportExcel', { filteredTerm: this.appliedTerm, filteredStartDate: this.filteredStartDate, filteredEndDate: this.filteredEndDate })
      this.requestLoading = false
    },
    infoTab () {
      this.activeTab = 'left'
    },
    async docsTab () {
      this.activeTab = 'right'
      if (this.loadDocs) {
        this.smallLoading = true
        await this.$store.dispatch('recruit/getApplicationFilesData', this.formData.id)
        this.fileList = this.fileList.map(appFile => {
          const matchingData = this.getbackendAppicationFilesData.find(data => data.type === appFile.title)
          if (matchingData) {
            const fileExtension = matchingData.filePath.split('.').pop()
            return {
              ...appFile,
              file: null,
              id: matchingData.id,
              name: matchingData.fileName + '.' + fileExtension,
              url: matchingData.filePath,
              extension: '.' + fileExtension,
              size: ''
            }
          }
          return {
            ...appFile,
            file: null,
            id: 0,
            name: null,
            url: null,
            extension: null,
            size: ''
          }
        })
        this.tempFileList = [...this.fileList]
        this.smallLoading = false
        this.loadDocs = false
      }
    },
    async downloadFile (url, name) {
      try {
        // Fetch file with authentication
        const response = await axios.get(url, {
          responseType: 'blob', // Get binary data
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        })

        // Create a Blob URL
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]))

        // Create a temporary link and trigger download
        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute('download', name) // Set file name
        document.body.appendChild(link)
        link.click() // Trigger download

        // Cleanup
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
      } catch (error) {
        console.error(`Error downloading ${name}:`, error)
        this.$showError('Đã xảy ra lỗi không mong muốn')
      }
    },
    // async loadFiles () {
    //   await this.$store.dispatch('recruit/getApplicationFilesData', this.formData.id)
    // },
    changeFile (event, index) {
      const file = event.target.files[0]
      if (file) {
        // Update the object in the list at the specified index
        const formatFileSize = (size) => {
          if (size < 1024) return `${size} B` // Bytes
          if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB` // Kilobytes
          return `${(size / (1024 * 1024)).toFixed(2)} MB` // Megabytes
        }

        this.fileList[index] = {
          id: this.fileList[index].id,
          title: this.fileList[index].title,
          name: file.name,
          url: URL.createObjectURL(file),
          size: formatFileSize(file.size),
          extension: '.' + file.name.split('.').pop().toLowerCase(),
          file: file
        }
      } else {
        // Reset the object if no file is chosen
        // this.fileList[index] = { id: this.fileList[index].id, title: this.fileList[index].title, name: '', url: '', extension: '', size: '', file: null }
        this.fileList[index] = this.tempFileList[index]
      }
    },
    getFileType (type) {
      if (type === '.pdf') return 'pdf.png'
      else if (type === '.xlsx') return 'excel.png'
      else if (type === '.docx' || type === '.doc') return 'word.png'
      else if (type === '.pptx') return 'powerpoint.png'
      else if (type === '.rar' || type === '.zip') return 'rar.png'
      else if (type === '.png' || type === '.jpg') return 'pictureIcon.png'
      else return 'document.png'
    },
    truncatedFileName (name, maxLength = 30) {
      if (name.length > maxLength) {
        return name.slice(0, maxLength) + '...'
      }
      return name
    },
    deleteAppFile (index) {
      this.fileList[index] = this.tempFileList[index]
    },
    //
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        this.getApplicationPageData()
      }
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    formatDate (dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-GB')
    },
    validateVariable () {
      this.isValid = true

      this.propertiesToCheck.forEach(key => {
        if (!this.vnData[key] || this.vnData[key] === 0) {
          this.isValid = false
          this.msg = 'Thiếu thông tin vn cần thiết'
        } else if (!this.enData[key] || this.enData[key] === 0) {
          this.isValid = false
          this.msg = 'Thiếu thông tin en cần thiết'
        }
      })
    },
    async getApplicationPageData () {
      this.isLoading = true

      this.totalPages = await this.$store.dispatch('recruit/getApplicationsByPageWithFilter', {
        filteredTerm: this.appliedTerm,
        pageNumber: this.currentPage,
        filteredStartDate: this.filteredStartDate,
        filteredEndDate: this.filteredEndDate
      })
      const ids = this.$store.getters['recruit/getAppicationIds']
      if (ids.length > 0) {
        this.currentApplicationFile = await this.$store.dispatch('recruit/getFilesChecked', { ids: ids })
      } else {
        if (this.currentPage > 1) {
          this.currentPage--
          this.totalPages = await this.$store.dispatch('recruit/getApplicationsByPageWithFilter', {
            filteredTerm: this.appliedTerm,
            pageNumber: this.currentPage,
            filteredStartDate: this.filteredStartDate,
            filteredEndDate: this.filteredEndDate
          })
        }
        if (this.totalPages < 1) this.totalPages = 1
      }

      this.isLoading = false
    },
    async generateWordFile (appData) {
      const doc = new Document({
        sections: [
          {
            children: [
              new Paragraph({
                children: [new TextRun({ text: 'Thông tin học viên', bold: true, size: 48 })],
                alignment: AlignmentType.CENTER // Center the text
              }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Full Name: ${appData.fullName}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Gender: ${appData.gender ? 'Nam' : 'Nữ'}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Birthday: ${appData.formattedBirthday}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Age: ${appData.age}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Birth Place: ${appData.birthPlace}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Permanent Address: ${appData.permanentAddress}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Citizen ID: ${appData.citizenIdentificationCard}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Place of Issue: ${appData.placeOfIssue}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Date of Issue: ${appData.formattedDateOfIssue}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Phone Number: ${appData.phoneNumber}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Email: ${appData.email}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Education Level: ${appData.educationLevel}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `English Certificate: ${appData.englishCertificate}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Father's Name: ${appData.fatherName}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Mother's Name: ${appData.motherName}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Father's Birth Year: ${appData.fatherBirthYear}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Mother's Birth Year: ${appData.motherBirthYear}`, size: 28 })] }),
              new Paragraph(''),
              new Paragraph({ children: [new TextRun({ text: `Parent Phone Number: ${appData.parentPhoneNum}`, size: 28 })] })
            ]
          }
        ]
      })

      // Generate the Word document as a Blob
      const blob = await Packer.toBlob(doc)
      // Convert Blob to a File object and store it
      this.wordFile = new File([blob], 'User_Info.docx', {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      })

      // Download the file immediately
      // saveAs(this.wordFile)
    },
    async downloadZip (appData) {
      this.formData.id = appData.id
      this.loadDocs = true

      await this.docsTab()
      const zip = new JSZip()

      await this.generateWordFile(appData)

      // const wordArrayBuffer = await this.wordFile.arrayBuffer()
      // zip.file('Info.docx', wordArrayBuffer, { binary: true })

      zip.file('Thông tin học viên.docx', this.wordFile) // Add file to ZIP

      const filePromises = this.fileList.map(async (fileData) => {
        try {
          // Fetch file with authentication (without baseURL)
          const response = await axios.get(fileData.url, {
            responseType: 'blob', // Ensure binary data response
            headers: { Authorization: `Bearer ${this.$store.state.token}` } // Attach Bearer token
          })

          const blob = response.data // Axios stores the Blob in response.data
          zip.file(fileData.name, blob) // Add file to ZIP
        } catch (error) {
          console.error(`Error fetching ${fileData.name}:`, error)
          this.$showError(`Lỗi tải file ${fileData.name}`)
        }
      })

      // Wait for all files to be added
      await Promise.all(filePromises)

      // Excel file
      const excelFile = await this.$store.dispatch('recruit/exportPerExcel', { appId: appData.id })
      if (excelFile) {
        zip.file('Thông tin học viên.xlsx', excelFile)
      }

      const content = await zip.generateAsync({ type: 'blob' })
      // Create URL for the ZIP file
      const zipUrl = URL.createObjectURL(content)

      const a = document.createElement('a')
      a.href = zipUrl
      a.download = appData.fullName + '.zip'
      document.body.appendChild(a)
      a.click()

      // Clean up
      document.body.removeChild(a)
      URL.revokeObjectURL(zipUrl)
    },
    // validateVariable () {
    //   this.isValid = true
    //   this.propertiesToCheck.forEach(key => {
    //     if (this[key] === '') {
    //       this.isValid = false
    //     }
    //   })
    // },
    editClick (data) {
      this.smallLoading = false
      this.activeTab = 'left'
      this.loadDocs = true
      this.modalTitle = 'Chỉnh sửa phiếu đăng ký tuyển sinh'
      Object.assign(this.formData, {
        ...data,
        birthday: data.birthday?.split('T')[0] || null,
        dateOfIssue: data.dateOfIssue?.split('T')[0] || null
      })
      this.toggleModal()
    },
    async updateClick () {
      this.requestLoading = true
      const filesData = new FormData()

      filesData.append('updatedApplicationRequestDto', JSON.stringify(this.formData))
      // Append each file to the FormData
      this.fileList.forEach((fileObj) => {
        if (fileObj.file) {
          filesData.append('id', fileObj.id)
          filesData.append('files', fileObj.file)
          filesData.append('type', fileObj.title)
        }
      })
      // filesData.append('applicationId', 1)
      // for (const [key, value] of filesData.entries()) {
      //   console.log(`${key}:`, value)
      // }

      const updatedApplication = {
        id: this.formData.id,
        data: filesData
      }

      try {
        await this.$store.dispatch('recruit/updateApplication', updatedApplication)
        this.requestLoading = false
        this.getApplicationPageData()
        this.toggleModal()
        this.$showSuccess('Cập nhật thành công')
      } catch (error) {
        this.requestLoading = false
        this.$showError('Đã xảy ra lỗi không mong muốn')
      }
    },
    async deleteClick (id) {
      this.requestLoading = true
      await this.$store.dispatch('recruit/deleteApplication', id)
      this.requestLoading = false
      this.toggleAlert()
      this.getApplicationPageData()
    }
  },
  created () {
    this.getApplicationPageData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  /* th, td, button, p, input {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
  } */

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input[type="date"] {
    padding: 0px 5px;
  }

  #date-input {
    border: none;
    outline: none;
    background: transparent;
    position: absolute;
    top: 3px;
    left: 7px;
    font-size: 15px;
    background-color: white;
    width: 108px;
    height: 32px;
    padding: 0px;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border: 1px solid #0298cf;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  .action-holder button{
    margin: 0 5px;
    width: 35px;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 60px;
  }

  /* td:nth-child(2), td:nth-child(3), td:nth-child(4) {
    text-align: center;
  } */

  td:nth-child(6), td:nth-child(5) {
    text-align: center;
    width: 120px;
  }

  td:nth-child(4), td:nth-child(3) {
    text-align: center;
  }

  th:nth-child(7), td:nth-child(7) {
    text-align: center;
    padding: 10px 7px;
    width: 80px;
  }

  td:nth-child(2) {
    min-width: 220px;
    text-align: center;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */
  .section-btn {
    width: 200px;
  }

  /* .switching-btn {

  } */

  .toggle-switch-btn {
    background-color: #0298cf;
    margin-right: 10px;
  }

  .form-body span{
    font-weight: bold;
    font-size: 18px;
  }

  .form-control {
    margin: 0.8rem 0;
  }

  .muti-data {
    display: flex;
    flex-direction: row;
    gap: 0 20px;
  }

  .data-input {
    flex: 1;
    position: relative;
  }

  .data-input a {
    text-decoration: none;
  }

  .data-input img {
    width: 17px;
    height: 17px;
    margin-right: 5px;
  }

  .data-input-file {
    width: 120px;
  }

  .data-input-file input[type="file"] {
    margin: 0px;
    padding: 0px;
    height: auto;
    display: none;
  }

  .data-input-file label {
    display: inline-block;
    text-transform: uppercase;
    color: #fff;
    background: #0076bb;
    text-align: center;
    padding: 7px;
    font-size: 10px !important;
    letter-spacing: 1.5px;
    user-select: none;
    cursor: pointer;
    border-radius: 3px;
  }

  .data-input-file i {
    margin-right: 5px;
  }

  .data-input-file label:active {
    transform: scale(0.9);
  }

  .formated-date {
    position: absolute;
    top: 33px;
    left: 8px;
    font-size: 16px;
    background-color: white;
    padding: 5px 7px;
  }
/*
  .form-control.invalid input {
    border-color: red;
  }

  .form-control.invalid label {
    color: red;
  } */

  .form-control label {
    font-size: 16px;
  }

  .form-control input {
    display: block;
    width: 100%;
    height: 40px;
    font: inherit;
    margin-top: 0.5rem;
    background: transparent;
    border: none;
    outline: none;
    border: 2px solid #ababab;
    border-radius: 5px;
    font-size: 16px;
    color: #424242;
    padding: 10px 0px;
    padding-left: 7px;
  }

  .birth {
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .birth span {
    margin: 0px 0.5rem;
    margin-top: 0.5rem;
  }

  .form-control-birth #bỉth {
    display: block;
    width: 100%;
    font: inherit;
    margin-top: 0.5rem;
  }

  .files-container {
    padding: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 20px;
    row-gap: 17px;
    width: 100%;
  }

  .file {
    height: 98px;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .file p{
    margin-top: 5px;
    color: black;
    font-size: 12px;
  }

  .file a {
    text-align: center;
    z-index: 1;
    pointer-events: auto;
    text-decoration: none;
  }

  .file-link {
    display: flex;
    align-items: center;
  }

  /* .close-icon {
    position: absolute;
    right: 0;
    z-index: 2;
    width: 15px;
    height: 19px;
    cursor: pointer;
    pointer-events: auto;
    transition: color 0.3s ease-out;
  }

  .close-icon:hover {
    color: red;
  } */

  /* .application-content button {
    margin-top: 20px;
    font: inherit;
    border: 1px solid #0076bb;
    background-color: #0076bb;
    color: white;
    cursor: pointer;
    padding: 0.75rem 2rem;
    border-radius: 30px;
  } */

  input[type='file'] {
    color: rgba(0, 0, 0, 0);
    border: none;
    padding-left: 0px;
  }

  /* input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  } */

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    padding: 12px;
  }

  .btn-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .header-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-content input {
    border-radius: 6px;
  }

  .excel-btn {
    position: relative;
    padding: 10px 20px;
    background-color: #008000;
  }

  .excel-btn p{
    color: #fff;
  }
</style>
